/**
 * Supported recurrence schedule `Period` units. This is a subset of ISO-8601 period format `PnYnMnD` with only the units listed below being supported.
 * @see https://github.com/Iterable/Iterable/pull/14710/files#diff-f106efd95718c850a4168fd6f72a97588e42350ce3dc8c49a7880d55400e0b9dR29-R30
 */
export enum PeriodUnit {
  Day = 'D',
  Month = 'M',
}

/**
 * A `RecurrenceSchedule` period formatted as `Pn{M|D}` where nM means n months and nD means n days. This is a subset of ISO-8601 period format PnYnMnD.
 * @see https://github.com/Iterable/Iterable/blob/309de402ae0e822c3de7cfd17e28b9e75f729ab1/platform/app/com/iterable/models/RecurrenceSchedule.scala
 * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
 */
export type PeriodString = `P${number}${PeriodUnit}`;

/**
 * Supported `RecurrenceSchedule` adjustments types
 */
export enum RecurrenceAdjustmentType {
  DayOfMonth = 'DayOfMonth',
}

export type RecurrenceAdjustment = {
  type: RecurrenceAdjustmentType;
  day: number;
};

/**
 * @see https://github.com/Iterable/Iterable/blob/309de402ae0e822c3de7cfd17e28b9e75f729ab1/platform/app/com/iterable/models/RecurrenceSchedule.scala
 */
export type RecurrenceSchedule = {
  period: PeriodString;
  adjustments: RecurrenceAdjustment[];
};
